import { memo } from 'react';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import ProductBrandAndComparison from '../ProductBrandAndComparison';
import ProductRatingStars from '../ProductRatingStars';
import RichTextContainer from '@components/cms/RichTextContainer';
import DOMPurify from 'isomorphic-dompurify';
import ProductMetaTags from './ProductMetaTags/ProductMetaTags';
import ClipboardCopy from '../ClipboardCopy';

import styles from './ProductMetaInfo.module.scss';

interface ProductMetaInfoProps {
  product: MecProduct;
  productCode: string;
  reviewsLink: string;
  scrollToProductReviewsAndAnswers?: () => void;
}

const ProductMetaInfo = ({
  product,
  productCode,
  reviewsLink,
  scrollToProductReviewsAndAnswers,
}: ProductMetaInfoProps) => {
  const numberOfReviews = product?.reviewSummary?.numberOfReviews;
  const hasPositiveReviewCount =
    typeof numberOfReviews === 'number' && numberOfReviews > 0;

  return (
    <div className={styles.container}>
      <ProductBrandAndComparison product={product} productCode={productCode} />
      <h1 className={styles.productName}>{product.name}</h1>
      <ClipboardCopy copyText={productCode} product={product} />
      <ProductRatingStars
        reviewsLink={reviewsLink}
        rating={product?.reviewSummary?.summationOfRatings}
        reviewCount={numberOfReviews}
        showNumericRating={hasPositiveReviewCount}
        showReviewCount={hasPositiveReviewCount}
        starSize="Small"
        scrollToProductReviewsAndAnswers={scrollToProductReviewsAndAnswers}
      />

      <ProductMetaTags productTags={product?.productTags} />

      {product?.shortDescription && (
        <RichTextContainer classNames={styles.productDescription}>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(product?.shortDescription),
            }}
          />
        </RichTextContainer>
      )}
    </div>
  );
};

export default memo(ProductMetaInfo);
